import React, { useState } from "react";
import { DeletePromocodeAPI } from "../../../../utils/APIs/promocodeApis";
import { toast } from "react-toastify";
import "./DeletePromocodeModal.css";

const DeletePromocodeModal = ({ isOpen, onClose, refreshData, promocode }) => {
  const [loading, setLoading] = useState(false);

  if (!isOpen) return null;

  const handleDelete = async () => {
    try {
      setLoading(true);
      const res = await DeletePromocodeAPI(promocode._id);

      if (res?.data?.success) {
        toast.success("Promocode deleted successfully");
        refreshData();
        onClose();
      } else {
        toast.error(res?.data?.message || "Failed to delete promocode");
      }
    } catch (err) {
      toast.error("Something went wrong");
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="modal-overlay">
      <div className="modal-box delete-modal">
        <h3>Delete Promocode</h3>
        <p>Are you sure you want to delete promocode <strong>{promocode.code}</strong>?</p>
        <p>This action cannot be undone.</p>
        
        <div className="modal-actions">
          <button className="btn-secondary" onClick={onClose}>
            Cancel
          </button>
          <button
            className="btn-danger"
            onClick={handleDelete}
            disabled={loading}
          >
            {loading ? "Deleting..." : "Delete"}
          </button>
        </div>
      </div>
    </div>
  );
};

export default DeletePromocodeModal;
